import { render, staticRenderFns } from "./contestFeedbackForm.html?vue&type=template&id=2caa93bc&scoped=true&"
import script from "./contestFeedbackForm.js?vue&type=script&lang=js&"
export * from "./contestFeedbackForm.js?vue&type=script&lang=js&"
import style0 from "./contestFeedbackForm.scss?vue&type=style&index=0&id=2caa93bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caa93bc",
  null
  
)

export default component.exports